import React from 'react';
import { Link } from 'react-router-dom';
import HomeTwoSingleAbout from '../../../components/HomeTwoSingleAbout/HomeTwoSingleAbout';
import { useTranslation } from 'react-i18next';

const HomeTwoAbout = () => {
   const { t, i18n } = useTranslation();

   return (
      <>
         <section className="about-area about-area-mid pt-80 pb-90">
            <div className="container">
               <div className="row">
                  <div className="col-xl-6 col-lg-12 col-md-12">
                     <div className="row">

                        <HomeTwoSingleAbout icon="5" title={`${t('mainPage.mesotherapy')}`} link={i18n.language === 'en' ? "/en/applications/mesotherapy-applications" : "/uygulamalar/mezoterapi-uygulamalari"} spacing="b-10" description={`${t('mainPage.mesotherapyDesc')}`} />
                        <HomeTwoSingleAbout icon="2" title={`${t('mainPage.fillingApplications')}`} link={i18n.language === 'en' ? "/en/applications/filler-applications" : "/uygulamalar/dolgu-uygulamalari"} spacing="t-10" description={`${t('mainPage.fillingApplicationsDesc')}`} />
                        <HomeTwoSingleAbout icon="6" title={`${t('mainPage.faceLifting')}`} link={i18n.language === 'en' ? "/en/applications/thread-applications" : "/uygulamalar/iple-olan-uygulamalar"} description={`${t('mainPage.faceLiftingDesc')}`} />
                        <HomeTwoSingleAbout icon="7" title={`${t('mainPage.healthyLiving')}`} link={i18n.language === 'en' ? "/en/applications/healthy-living" : "/uygulamalar/saglikli-yasam"} spacing="t-10" description={`${t('mainPage.healthyLivingDesc')}`} />
                        <HomeTwoSingleAbout icon="8" title={`${t('mainPage.deviceOperations')}`} link={i18n.language === 'en' ? "/en/applications/device-procedures" : "/uygulamalar/cihaz-islemleri"} spacing="b-10" description={`${t('mainPage.deviceOperationsDesc')}`} />
                        <HomeTwoSingleAbout icon="1" title={`${t('mainPage.medicalTreatments')}`} link={i18n.language === 'en' ? "/en/applications/medical-applications" : "/uygulamalar/medikal-uygulamalar"} spacing="t-10" description={`${t('mainPage.medicalTreatmentsDesc')}`} />

                     </div>
                  </div>

                  <div className="col-xl-6 col-lg-12 col-md-11">
                     <div className="about-right-side pt-25 mb-30">
                        <div className="about-title mb-20">
                           <h3 className="pink-color">{t('mainPage.welcome')}</h3>
                           <h3>{t('mainPage.drTitle')}</h3>
                           <br />
                        </div>
                        <div className="about-text">
                           <p>
                              {t('mainPage.aboutDesc1')}
                              <br /><br /> {t('mainPage.aboutDesc2')}
                              <br /><br /> {t('mainPage.aboutDesc3')}  <br />
                              <span style={{ fontStyle: "italic", fontWeight: "bold" }}>
                                 “{t('mainPage.aboutDesc4')}” </span> <br /><br />
                              <span style={{ fontStyle: "italic", fontWeight: "bold" }}> {t('mainPage.aboutDesc5')} </span>
                              {t('mainPage.aboutDesc6')}
                           </p><br />
                        </div>
                        <div className="button-area">
                           <Link to={i18n.language === 'en' ? "/en/resume" : "/ozgecmis"} className="primary_btn btn-icon ml-0"><span><i className="fab fa-leanpub"></i></span>{t('mainPage.readMore')}</Link>
                        </div>
                     </div>
                  </div>

               </div>
            </div>
         </section>
      </>
   );
};

export default HomeTwoAbout;
